import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home, house"} maskId="square-filled-radius-0-stroke-1-IconHome"><path fillRule="evenodd" clipRule="evenodd" d="M12 1.35815L21 8.60312V21H3V8.60312L12 1.35815Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHome;
